import React, { useState, useEffect } from "react";
import PageLayout from "../../../Layouts/PageLayout/PageLayout";
import Table from "../../../components/common/Table/Table";
import { getApiInstance } from "../../../utils/api";
import { useZone } from "../../../context/ZoneContext";
import { useTranslation } from "react-i18next";

export default function Intermediarios({ user }) {
    const { t } = useTranslation();
    const [intermediarios, setIntermediarios] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { selectedZone } = useZone();

    const filterFields = [
        {
            key: "nombre",
            label: t("intermediaries.columns.name"),
            type: "multiselect",
        },
        {
            key: "cif",
            label: t("intermediaries.columns.cif"),
            type: "multiselect",
        },
        {
            key: "contacto",
            label: t("intermediaries.columns.contact"),
            type: "multiselect",
        },
        {
            key: "telefono",
            label: t("intermediaries.columns.phone"),
            type: "multiselect",
        },
    ];

    const columnasIntermediarios = [
        { key: "id", label: "codIntermediario", visible: false },
        { key: "codIntermediario", label: "codIntermediario", visible: false },
        {
            key: "nombre",
            label: t("fields.name"),
            visible: true,
            sortable: true,
        },
        {
            key: "cif",
            label: t("fields.cif"),
            visible: true,
            sortable: true,
            visibleOnExpand: true,
        },
        {
            key: "contacto",
            label: t("fields.contact"),
            visible: true,
            sortable: true,
            visibleOnExpand: true,
            render: (row) => {
                return (
                    <div className="table-cell-content">
                        <span className="table-cell-content__primary">
                            {row.contacto || "-"}
                        </span>
                        <span className="table-cell-content__secondary">
                            {row.eMail || ""}
                        </span>
                    </div>
                );
            },
        },
        {
            key: "telefono",
            label: t("fields.phone"),
            visible: true,
            sortable: true,
            visibleOnExpand: true,
        },
        {
            key: "eMail",
            label: t("fields.email"),
            visible: false,
            sortable: false,
        },
    ];

    useEffect(() => {
        fetchIntermediarios();
    }, [selectedZone]);

    const fetchIntermediarios = async () => {
        setLoading(true);
        const api = getApiInstance();

        try {
            let intermediariosData = [];

            const response = await api.get(
                `/api/Intermediarios/GetIntermediariosByZona/${selectedZone.value}`
            );
            intermediariosData = response.data;

            setIntermediarios(intermediariosData);
            setError(null);
        } catch (err) {
            setError(
                "No se han podido cargar los intermediarios. Vuelve a intentarlo más tarde."
            );
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <PageLayout
            title={t("intermediaries.title")}
            subtitle={t("intermediaries.subtitle")}
        >
            <Table
                columns={columnasIntermediarios}
                dataTable={intermediarios}
                showCheckboxes={true}
                expandable={true}
                expandableBreakpoint={600}
                noResultsMessage={t("intermediaries.noIntermediariesFound")}
                actions={["Eliminar", "Editar"]}
                searchTerms={[
                    t("fields.name"),
                    t("fields.cif"),
                    t("fields.contact"),
                    t("fields.phone"),
                    t("fields.email"),
                ]}
                elementName={t("fields.intermediary")}
                formElements={[
                    {
                        elements: [
                            {
                                name: "nombre",
                                type: "text",
                                label: t("fields.name"),
                                placeholder: t(
                                    "intermediaries.form.namePlaceholder"
                                ),
                                required: true,
                                disabled: false,
                                labelVisible: true,
                                visible: true,
                            },
                            {
                                name: "cif",
                                type: "text",
                                label: t("fields.cif"),
                                placeholder: t(
                                    "intermediaries.form.cifPlaceholder"
                                ),
                                required: true,
                                disabled: false,
                                labelVisible: true,
                                visible: true,
                            },
                            {
                                name: "direccion",
                                type: "text",
                                label: t("fields.address"),
                                placeholder: t(
                                    "intermediaries.form.addressPlaceholder"
                                ),
                                required: true,
                                disabled: false,
                                labelVisible: true,
                                visible: true,
                            },
                            {
                                name: "localidad",
                                type: "text",
                                label: t("fields.locality"),
                                placeholder: t(
                                    "intermediaries.form.localityPlaceholder"
                                ),
                                required: true,
                                disabled: false,
                                labelVisible: true,
                                visible: true,
                            },
                            {
                                name: "contacto",
                                type: "tel",
                                label: t("fields.contact"),
                                placeholder: t(
                                    "intermediaries.form.contactPlaceholder"
                                ),
                                required: true,
                                disabled: false,
                                labelVisible: true,
                                visible: true,
                            },
                            {
                                name: "telefono",
                                type: "tel",
                                label: t("fields.phone"),
                                placeholder: t(
                                    "intermediaries.form.phonePlaceholder"
                                ),
                                required: true,
                                disabled: false,
                                labelVisible: true,
                                visible: true,
                            },
                            {
                                name: "eMail",
                                type: "email",
                                label: t("fields.email"),
                                placeholder: t(
                                    "intermediaries.form.emailPlaceholder"
                                ),
                                required: true,
                                disabled: false,
                                labelVisible: true,
                                visible: true,
                            },
                            {
                                name: "codZona",
                                type: "number",
                                label: "Zona",
                                visible: false,
                                defaultValue: selectedZone.value,
                            },
                        ],
                    },
                ]}
                filterFields={filterFields}
                loading={loading}
                keyProp="codIntermediario"
                sortProp="nombre"
                addApiUrl="/api/Intermediarios/SetIntermediario"
                editApiUrl="/api/Intermediarios/UpdateIntermediario"
                deleteApiUrl="/api/Intermediarios/DeleteIntermediario"
                userCodAcceso={Number(user.codAcceso)}
                userCodPerfil={Number(user.role)}
            />
        </PageLayout>
    );
}
